import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { ParametroOpcaoModel } from 'model/api/gestao/parametro/parametro-opcao-model';

export function useGetParametrosOpcoes() {
  const { invocarApi, ...outrasPropriedades } =
    useApiBase<ParametroOpcaoModel[]>();

  const getParametroOpcoes = useCallback(
    async (id: string) => {
      return invocarApi({
        url: `${VariaveisAmbiente.apiVersion}/parametro/${id}/opcao`,
        method: 'GET',
        enviarTokenUsuario: true,
      });
    },
    [invocarApi],
  );
  return {
    ...outrasPropriedades,
    getParametroOpcoes,
  };
}
